<template>
  <v-select
    v-model="selectedChitType"
    :items="chitOptions"
    item-title="text"
    item-value="id"
    variant="outlined"
    hide-details="auto"
    density="compact"
    :loading="isPending"
    :error-messages="combinedErrorMessages"
  />
</template>

<script setup lang="ts">
import { useFetchChitOptions } from '@/composables/chit'
import { ChitOptionType, type IChitOptionData } from '@/models/chit'
import { isArray } from 'lodash'
import { computed, type PropType } from 'vue'

const selectedChitType = defineModel<(number | IChitOptionData)[] | null>({ default: null })

const { isPending, error: fetchError, chitOptions } = useFetchChitOptions(ChitOptionType.Type)

const props = defineProps({
  errorMessages: {
    type: [String, Array, null] as PropType<string | string[] | null>,
    default: () => []
  }
})

const combinedErrorMessages = computed(() => {
  let error: string[] = []

  if (fetchError.value) {
    error.push(fetchError.value.message)
  }
  if (isArray(props.errorMessages)) {
    error.concat(props.errorMessages)
  } else {
    if (props.errorMessages) {
      error.push(props.errorMessages)
    }
  }

  return error
})
</script>
